import { Button } from '@ifood/pomodoro-components';
import styled from 'styled-components';

export const ActionButton = styled(Button)`
  background: transparent;
  display: block;
  margin: auto;
  padding: 0;

  &:hover:not(:active):not(:disabled),
  &:active,
  &:focus {
    background-color: transparent;
    box-shadow: none;
  }

  > div {
    min-width: 130px;
  }
`;
